import { useCallback } from 'react';
import { useDispatch } from '@lingoda/hooks';
import { clearAuthCookies, logout as logoutAction } from '@lingoda/auth';
import { useGQLClient } from '@lingoda/monolith-graphql';
import { useQuizClient } from '@lingoda/quiz-graphql';
import { cleanUpPostFFreeTrialDialogCloseDate } from '@lingoda/f-free-trial-utils';

export const useLogout = () => {
    const dispatch = useDispatch();
    const gqlClient = useGQLClient();
    const quizClient = useQuizClient();

    return useCallback(async () => {
        cleanUpOnLogout();
        await gqlClient.clearStore();
        await quizClient.clearStore();
        dispatch(logoutAction());
        await clearAuthCookies();
    }, [dispatch, gqlClient, quizClient]);
};

export const cleanUpOnLogout = () => {
    cleanUpPostFFreeTrialDialogCloseDate();
};
